import { MODULE_TYPES } from 'constants/common'
import LabelTypes from 'store/actionTypes/label'
import UserTypes from 'store/actionTypes/user'
import { getTranslationLabels } from '../mapping/shared'

const initialData = {
  list: [],
  systems: {},
  current: {},
  pagination: {},
  pages: [],
  filter: {
    [MODULE_TYPES.CIXI_CENTER]: {},
    [MODULE_TYPES.MOBILE_APP]: {},
    [MODULE_TYPES.SERVICE_CENTER]: {}
  }
}

const label = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case LabelTypes.GET_LABELS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case LabelTypes.GET_SYSTEM_LABELS_SUCCESS:
      return { ...state, systems: getTranslationLabels(payload?.items) }
    case LabelTypes.UPDATE_FILTER_LABEL_SUCCESS:
      return {
        ...state,
        filter: {
          ...state.filter,
          [payload?.moduleName]: payload?.data
        }
      }
    case LabelTypes.UPDATE_LABEL_FROM_PAGE_TITLE_SUCCESS:
      return { ...state, systems: { ...state.systems, ...payload } }
    case LabelTypes.GET_PAGES_BY_MODULE_ID_SUCCESS:
      return { ...state, pages: payload?.pageKeyword }
    case UserTypes.LOGOUT_SUCCESS:
      return {
        ...initialData,
        systems: state.systems
      }
    default:
      return state
  }
}

export default label
